<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <v-card class="ma-3" outlined elevation="2" style="height: 'min-content'">
      <div
        :style="{ padding: '25px', paddingBottom: '10px', fontSize: 'small' }"
      >
        <v-row>
          <v-col cols="10" sm="2"> MID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="9">
            {{ midParent }}
          </v-col>
        </v-row>
      </div>

      <v-data-table
        :headers="headers"
        :items="allData"
        :options.sync="options"
        :server-items-length="totalData"
        :loading="loading"
        loading-text="Loading... Please wait"
        :item-class="rowClass"
        class="d-print-table"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 25, 50],
          // showFirstLastPage: true,
        }"
        item-key="id"
        sort-by="merchant_name"
        :sort-desc="true"
        :style="{ padding: '10px' }"
        fixed-header
      >
        <template v-slot:[`item.id`]="{ index }">
          {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            class="ma-2"
            small
            :color="item.status == 'active' ? '#C3F5BE' : '#FFC5CD'"
            :text-color="item.status == 'active' ? '#09682D' : '#C50F0F'"
            min
            :style="{
              'min-width': '160px',
              'justify-content': 'center',
            }"
          >
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  data: () => ({
    switchCh: true,
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    isFirstLoad: false,
    options: {},
    dialog: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Merchant',
        value: 'merchant_name',
        width: '150',
        sortable: false,
        align: 'left',
      },
      {
        text: 'Tanggal Active',
        value: 'created_date',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Status',
        value: 'status',
        width: '150',
        sortable: false,
        align: 'center',
      },
    ],
    search: {
      mid: '',
    },
    editedItem: {
      mid: '',
    },
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.mid.detailDuplicateMid.allData;
    },
    totalData() {
      return this.$store.state.mid.detailDuplicateMid.totalData;
    },
    totalPage() {
      return this.$store.state.mid.detailDuplicateMid.totalPage;
    },
    loading() {
      return this.$store.state.mid.detailDuplicateMid.loading;
    },
    flashError: {
      get() {
        return this.$store.state.mid.detailDuplicateMid.flashError;
      },
      set() {
        this.$store.commit('mid/detailDuplicateMid/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.mid.detailDuplicateMid.flashErrorMessage;
    },
    midParent() {
      return this.$route.params.id;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('mid/detailDuplicateMid/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      const source = this.checkEnvCh;
      this.$store.commit('mid/detailDuplicateMid/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('mid/detailDuplicateMid/getData', {
          mid: this.midParent,
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          source,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    closeFlash() {
      this.$store.commit('mid/detailDuplicateMid/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.mid = '';
      this.$nextTick(() => {
        this.$store.commit('mid/detailDuplicateMid/clearData');
      });
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
